import { ref, type Ref } from 'vue';
import { Gewaesser } from "./Gewaessernetz"

export class SelectedData {
  fixedKm: Ref<object | null | undefined>;
  movingKm: Ref<number | null | undefined>;
  selectedGewaesser: Ref<string | null | undefined>;

  constructor() {
    this.fixedKm = ref(null);
    this.movingKm = ref(null);
    this.selectedGewaesser = ref(null);
  }

  setGewaesser(nr: string | null | undefined) {
    this.selectedGewaesser.value = nr;
  }

  getGewaesser() {
    return this.selectedGewaesser.value;
  }

  setFixedKm(km: object | null | undefined) {
    this.fixedKm.value = km;
  }

  getFixedKm() {
    return this.fixedKm.value;
  }

  setMovingKm(km: number | null | undefined) {
    this.movingKm.value = km;
  }

  getMovingKm() {
    return this.movingKm.value;
  }
}